const stickyApartmentInfo = () => {
    const wrapper = document.querySelector('[data-sticky-wrapper]');
    const column = wrapper
        ? wrapper.querySelector('[data-sticky-column]')
        : null;
    const gallery = document.querySelector('[data-sticky-gallery]');
    const header = document.querySelector('.header');

    if (!wrapper || !column || !gallery) {
        return;
    }

    const desktopBreakpoint = 1024;

    let wrapperTop = 0;
    let galleryBottom = 0;
    let columnHeight = 0;
    let state = 'static';

    const resetStyles = () => {
        column.style.position = '';
        column.style.top = '';
        column.style.bottom = '';
        column.style.left = '';
        column.style.width = '';
        wrapper.style.minHeight = '';
    };

    const isDesktop = () => window.innerWidth >= desktopBreakpoint;

    const getHeaderOffset = () => {
        if (!header) {
            return 0;
        }

        const rect = header.getBoundingClientRect();
        return Math.max(rect.bottom - 16, 0);
    };

    const calculateBoundaries = () => {
        if (!isDesktop()) {
            state = 'static';
            wrapper.style.position = '';
            wrapper.style.minHeight = '';
            wrapperTop = 0;
            galleryBottom = 0;
            columnHeight = 0;
            return;
        }

        wrapper.style.position = 'relative';

        const wrapperRect = wrapper.getBoundingClientRect();
        const galleryRect = gallery.getBoundingClientRect();
        const scrollY = window.scrollY;

        columnHeight = column.offsetHeight;
        wrapperTop = scrollY + wrapperRect.top;
        galleryBottom = scrollY + galleryRect.bottom;

        const requiredHeight = Math.max(
            columnHeight,
            galleryBottom - wrapperTop
        );

        wrapper.style.minHeight = `${requiredHeight}px`;
    };

    const setStatic = () => {
        if (state === 'static') {
            return;
        }

        column.style.position = 'static';
        column.style.top = '';
        column.style.bottom = '';
        column.style.left = '';
        column.style.width = '';
        state = 'static';
    };

    const setFixed = headerOffset => {
        const wrapperRect = wrapper.getBoundingClientRect();

        column.style.position = 'fixed';
        column.style.top = `${headerOffset}px`;
        column.style.left = `${wrapperRect.left}px`;
        column.style.width = `${wrapperRect.width}px`;
        column.style.bottom = '';
        state = 'fixed';
    };

    const setAbsolute = offset => {
        column.style.position = 'absolute';
        column.style.top = `${offset}px`;
        column.style.bottom = '';
        column.style.left = '0';
        column.style.width = '100%';
        state = 'absolute';
    };

    const updatePosition = () => {
        if (!isDesktop()) {
            resetStyles();
            wrapper.style.position = '';
            wrapper.style.minHeight = '';
            wrapperTop = 0;
            galleryBottom = 0;
            columnHeight = 0;
            state = 'static';
            return;
        }

        if (!wrapperTop && !galleryBottom) {
            calculateBoundaries();
        }

        const headerOffset = getHeaderOffset();
        const scrollY = window.scrollY;
        const startTrigger = wrapperTop - headerOffset;
        const endTrigger = galleryBottom - columnHeight - headerOffset;
        const absoluteOffset = Math.max(
            galleryBottom - columnHeight - wrapperTop,
            0
        );

        if (scrollY <= startTrigger) {
            setStatic();
            return;
        }

        if (scrollY >= endTrigger) {
            setAbsolute(absoluteOffset);
            return;
        }

        setFixed(headerOffset);
    };

    let ticking = false;

    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updatePosition();
                ticking = false;
            });
            ticking = true;
        }
    };

    const onResize = () => {
        wrapperTop = 0;
        galleryBottom = 0;
        columnHeight = 0;
        state = 'static';
        resetStyles();
        calculateBoundaries();
        updatePosition();
    };

    calculateBoundaries();
    updatePosition();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);

    if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(onResize);
        observer.observe(gallery);
        observer.observe(column);
    }
};

const bootStickyApartmentInfo = () => {
    stickyApartmentInfo();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStickyApartmentInfo, {
        once: true,
    });
} else {
    bootStickyApartmentInfo();
}

export default stickyApartmentInfo;
